var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0078 80.8L93.7078 100H84.3078L82.0078 80.8V52H96.0078V80.8ZM94.9078 108.7C96.6411 110.367 97.5078 112.333 97.5078 114.6C97.5078 116.867 96.6411 118.867 94.9078 120.6C93.2411 122.267 91.2745 123.1 89.0078 123.1C86.7411 123.1 84.7411 122.267 83.0078 120.6C81.3411 118.867 80.5078 116.867 80.5078 114.6C80.5078 112.333 81.3411 110.367 83.0078 108.7C84.7411 106.967 86.7411 106.1 89.0078 106.1C91.2745 106.1 93.2411 106.967 94.9078 108.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0078 77.8L89.7078 97H80.3078L78.0078 77.8V49H92.0078V77.8ZM90.9078 105.7C92.6411 107.367 93.5078 109.333 93.5078 111.6C93.5078 113.867 92.6411 115.867 90.9078 117.6C89.2411 119.267 87.2745 120.1 85.0078 120.1C82.7411 120.1 80.7411 119.267 79.0078 117.6C77.3411 115.867 76.5078 113.867 76.5078 111.6C76.5078 109.333 77.3411 107.367 79.0078 105.7C80.7411 103.967 82.7411 103.1 85.0078 103.1C87.2745 103.1 89.2411 103.967 90.9078 105.7Z",
    fill: "#4B27E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.fbf7015f.svg";
export { ForwardRef as ReactComponent };